export const environment = {
  //uri: 'https://192.168.0.152:7213/',
  uri: 'https://kayapidevappservice.azurewebsites.net/',
  production: true
};
